type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function Switch({ checked, onChange }: SwitchProps) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      style={{
        width: 30,
        height: 18,
        borderRadius: 999,
        padding: 2,
        background: checked ? "var(--brand-green)" : "var(--line-strong)",
        transition: "background 160ms ease",
        display: "flex",
        alignItems: "center",
      }}
    >
      <span
        style={{
          width: 14,
          height: 14,
          borderRadius: 999,
          background: "white",
          transform: checked ? "translateX(12px)" : "translateX(0)",
          transition: "transform 160ms ease",
          boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
        }}
      />
    </button>
  );
}
